import { resourceState, resourceMutations } from '@/store/utils/resource';
import { notificationChannelsClient as client } from '@/api/clients';
import { NOTIFICATION_CHANNELS } from '@/store/entities/schema_types';

export default {
  namespaced: true,

  state: resourceState(),

  mutations: resourceMutations,

  getters: {
    notificationChannels(state, _, rootState) {
      return state.ids.map((id) => rootState.entities.notificationChannels.byId[id]);
    },
  },

  actions: {
    async load(ctx, { params = {} } = {}) {
      try {
        const response = await client.list({ params });
        const { data: payload } = response;
        const { data, meta, links } = payload;

        const taskUuids = await ctx.dispatch(
          'entities/persistEntities',
          { type: NOTIFICATION_CHANNELS, data },
          { root: true }
        );

        ctx.commit('setIds', taskUuids);
        ctx.commit('setMeta', meta);
        ctx.commit('setLinks', links);

        return Promise.resolve(true);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
